var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBytesizeBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.241 7.72173C14.0465 5.10314 10.7742 10.8958 8.9038 16.0347C7.03338 21.1737 2.82776 23.1348 2.82776 23.1348L25.4391 31.3647C25.4391 31.3647 23.478 27.159 25.3484 22.0201C27.2188 16.8811 28.4356 10.3403 21.241 7.72173ZM21.241 7.72173L22.3633 4.63837M18.2446 28.7461C18.2446 28.7461 16.7483 32.8572 12.6371 31.3609C8.52594 29.8645 10.0223 25.7534 10.0223 25.7534",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBytesizeBell);
export default __webpack_public_path__ + "static/media/bytesize_bell.f3adb3441685e6b94d9527302496d9f0.svg";
export { ForwardRef as ReactComponent };